module.exports = __webpack_public_path__ + "img/ideation-2_jp.87ef7e7.jpg";